import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./pages/App";
import reportWebVitals from "./reportWebVitals";
import NavigationBar from "./components/UI/navigation/navigationBar";
import { RouterProvider } from "react-router-dom";
import { createBrowserRouter } from "react-router-dom";
import Trip from "./pages/Trip";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <NavigationBar />
    {/* <App /> */}
    <RouterProvider
      router={createBrowserRouter([
        {
          path: "/",
          element: <App />,
          errorElement: <div>404</div>,
        },
        {
          path: "/excursion/:id",
          element: <Trip type='excursion' />,
          errorElement: <div>404</div>,
        },
        {
          path: "/safari/:id",
          element: <Trip type='safari' />,
          errorElement: <div>404</div>,
        }
      ])}
    />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
